export default [
  {
    name: 'public.formulars',
    path: '/public/formulars',
    component: () => import("@/views/public/Index.vue"),
    children: [
      {
        name: 'public.formular.employee',
        path: 'employee',
        component: () => import("@v/formulars/employee/Index.vue"),
        children: [
          {
            name: 'public.formular.employee.checkin',
            path: 'checkin/:token',
            component: () => import("@v/formulars/employee/Checkin.vue"),
            props: true
          },
          {
            name: 'public.formular.employee.accidentreport',
            path: 'accidentreport/:token',
            component: () => import("@v/formulars/employee/Accidentreport.vue"),
            props: true
          },
          {
            name: 'public.formular.employee.evaluation',
            path: 'evaluation/:token',
            component: () => import("@v/formulars/employee/Evaluation.vue"),
            props: true
          },
          {
            name: 'public.formular.employee.docket',
            path: 'docket/:token',
            component: () => import("@v/formulars/employee/Docket.vue"),
            props: true
          },
          {
            name: 'public.formular.employee.personaccidentreport',
            path: 'personaccidentreport/:token',
            component: () => import("@v/formulars/employee/Personaccidentreport.vue"),
            props: true
          },
          {
            name: 'public.formular.employee.trainingproof',
            path: 'trainingproof/:token',
            component: () => import("@v/formulars/employee/Trainingproof.vue"),
            props: true
          }
        ]
      }
    ]
  },
  {
    name: 'private.formulars',
    path: '/private/formulars',
    component: () => import("@/views/private/Index.vue"),
    children: [
      {
        name: 'private.formular.employee',
        path: 'employee',
        component: () => import("@v/formulars/employee/Index.vue"),
        children: [
          {
            name: 'private.formular.employee.checkin',
            path: 'checkin/:id',
            component: () => import("@v/formulars/employee/Checkin.vue"),
            props: true
          },
          {
            name: 'private.formular.employee.accidentreport',
            path: 'accidentreport',
            component: () => import("@v/formulars/employee/Accidentreport.vue"),
          },
          {
            name: 'private.formular.employee.accidentreport.id',
            path: 'accidentreport/:id',
            component: () => import("@v/formulars/employee/Accidentreport.vue"),
            props: true
          },
          {
            name: 'private.formular.employee.evaluation',
            path: 'evaluation/:id',
            component: () => import("@v/formulars/employee/Evaluation.vue"),
            props: true
          },
          {
            name: 'private.formular.employee.docket',
            path: 'docket/:id',
            component: () => import("@v/formulars/employee/Docket.vue"),
            props: true
          },
          {
            name: 'private.formular.employee.personaccidentreport',
            path: 'personaccidentreport/:id',
            component: () => import("@v/formulars/employee/Personaccidentreport.vue"),
            props: true
          },
          {
            name: 'private.formular.employee.trainingproof',
            path: 'trainingproof/:id',
            component: () => import("@v/formulars/employee/Trainingproof.vue"),
            props: true
          }
        ]
      }
    ]
  },

]
